import { lazy } from "react";

const RETRY_PARAM = "_r";

const CHUNK_ERROR_PATTERNS = [
  "loading chunk",
  "loading css chunk",
  "unable to preload css",
  "failed to fetch dynamically imported module",
  "error loading dynamically imported module",
  "importing a module script failed",
  "failed to load module script",
  "is not a valid javascript mime type",
  "doesn't provide an export named",
  "does not provide an export named",
  "unexpected token",
  "load failed",
  "networkerror",
];

const isChunkLoadError = (error) => {
  if (error?.name === "ChunkLoadError") {
    return true;
  }
  const message = String(error?.message || "").toLowerCase();
  return CHUNK_ERROR_PATTERNS.some((pattern) => message.includes(pattern));
};

const reloadOnce = () => {
  if (typeof window === "undefined" || window.self === window.top) {
    return false;
  }
  const url = new URL(window.location.href);
  if (url.searchParams.has(RETRY_PARAM)) {
    return false;
  }
  url.searchParams.set(RETRY_PARAM, "1");
  window.location.replace(url.toString());
  return true;
};

const lazyWithRetry = (importFn) =>
  lazy(() =>
    importFn().catch((error) => {
      if (isChunkLoadError(error) && reloadOnce()) {
        return { default: () => null };
      }
      throw error;
    }),
  );

export default lazyWithRetry;
